import axios from 'axios';
import { getTotalPage } from '../admin/Admin';

export const login = (data) => {
    return (dispatch) => {
        axios
            .post('/driver/login', data)
            .then((data) => {
                localStorage.setItem('uid', data.data.data.id);
                localStorage.setItem('email', data.data.data.username);
                localStorage.setItem('name', data.data.data.name);
                localStorage.setItem('userLoginType', 'driver');
                setAuthorizationHandler(data.data.token);
                dispatch({ type: 'DRIVER_LOGIN', payload: data });
                dispatch({
                    type: 'SUCCESS_MESSAGE',
                    payload: { general: 'Login successful' }
                });
            })
            .catch((error) => {
                try {
                    dispatch({
                        type: 'ERROR_MESSAGE',
                        payload: { general: error.response.data.message }
                    });
                } catch {
                    dispatch({ type: 'ERROR_MESSAGE', payload: 'please try again' });
                }
            });
    };
};


export const pushLocation = (location) => {
    return (dispatch) => {
        return new Promise((resolve, reject) => {
            axios
                .post('/driver/push-location', location)
                .then(async (data) => {
                    resolve(true);
                })
                .catch((error) => {
                    try {
                        dispatch({
                            type: 'UPDATE_ERROR',
                            payload: error.response.data
                        });
                        reject(false);
                    } catch {
                        dispatch({
                            type: 'UPDATE_ERROR',
                            payload: 'please try again'
                        });
                    }
                });
        });
    };
}

const setAuthorizationHandler = (token) => {
    const fireToken = `Bearer${' ' + token}`;
    localStorage.setItem('token', fireToken);
};